import { useLocation } from "react-router-dom";
import cn from "classnames";
// Styles
import styles from "./Header.module.scss";
// Images
import logo from "../../assets/images/magna_pest_logo.png";

const Header = ({ withoutSteps }) => {
  const { pathname } = useLocation();

  const isActive = (path) => {
    return pathname === path;
  };

  const handleClickLogo = () => {
    window.open("https://www.magnapest.com/residential");
  };

  return (
    <header className={styles.root}>
      <img
        onClick={handleClickLogo}
        src={logo}
        alt="Magna Pest logo"
        className={styles.logoSection}
      />

      {!withoutSteps && (
        <div className={styles.stepperSection}>
          <div
            className={cn(styles.step, {
              [styles.active]: isActive("/contact"),
            })}
          >
            <span className={styles.stepNumber}>1</span>
            <span className={styles.stepText}>Contact</span>
          </div>

          <div
            className={cn(styles.step, {
              [styles.active]: isActive("/schedule"),
            })}
          >
            <span className={styles.stepNumber}>2</span>
            <span className={styles.stepText}>Schedule</span>
          </div>

          <div
            className={cn(styles.step, {
              [styles.active]: isActive("/checkout"),
            })}
          >
            <span className={styles.stepNumber}>3</span>
            <span className={styles.stepText}>Checkout</span>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
